//
// Module for the BalanceDetail Index view
//
rs.module("employer/reporting/balancedetail/index",

    ["controls/data/grid"],

    function (gridModule) {

        // Initialize the module
        function initialize(mainGridLrsApi, detailTransactionGridLrsApi, jsSelectors, ajaxUrls, codeValues, fundBalancingMethodCodeValue) {

            var footer = $.js(jsSelectors.totalBalanceFooter);

            if (fundBalancingMethodCodeValue == codeValues.balancingMethodBatch) {

                $.js(jsSelectors.filter).js(jsSelectors.batchNumberSelect).change(function () {

                    $.js(jsSelectors.filter).js(jsSelectors.loadingSpinner).show();

                    gridModule.update(
                        ajaxUrls.getBalanceDetailBatch,
                        { batchNumber: this.value },
                        mainGridLrsApi.agGridApi,
                        balanceDetailGridUpdateDone
                    );

                });

            } else if (fundBalancingMethodCodeValue == codeValues.balancingMethodFiscalYear) {

                $.js(jsSelectors.filter).js(jsSelectors.fiscalYearSelect).change(function () {

                    $.js(jsSelectors.filter).js(jsSelectors.loadingSpinner).show();

                    gridModule.update(
                        ajaxUrls.getBalanceDetailFiscalYear,
                        { fiscalYear: this.value },
                        mainGridLrsApi.agGridApi,
                        balanceDetailGridUpdateDone
                    );

                });

            }

            // On finish (done) of a balance detail grid update:
            // Update Total Balance, Update Detail Transactions, Hide Spinner
            function balanceDetailGridUpdateDone(gridUpdate) {
                footer.text(gridUpdate.context.balance);

                // Default the selection of the grid (which triggers the selectionChanged)
                // or clear the secondary grid (as there is nothing to display)
                if (mainGridLrsApi.agGridApi.getDisplayedRowCount() > 0) {
                    mainGridLrsApi.selectFirstRow();
                } else {
                    detailTransactionGridLrsApi.clearGridRows();
                }

                $.js(jsSelectors.filter).js(jsSelectors.loadingSpinner).hide();
            }

            // On balance detail grid selection change, update detail transactions
            mainGridLrsApi.selectionChanged(function (values, rows) {
                if (values.length > 0) {
                    refreshDetailTransaction(values[0], fundBalancingMethodCodeValue);
                }
            });

            // Update the detail transaction with selected balance detail
            function refreshDetailTransaction(tupleWithReceivableTypeAndBatchOrYear, fundBalancingMethodCodeValue) {
                if (tupleWithReceivableTypeAndBatchOrYear.Item1 != null &&
                    tupleWithReceivableTypeAndBatchOrYear.Item2 != null) {

                    gridModule.update(
                        ajaxUrls.getDetailTransactions,
                        {
                            receivableType: tupleWithReceivableTypeAndBatchOrYear.Item1,
                            batchOrYear: tupleWithReceivableTypeAndBatchOrYear.Item2,
                            fundBalancingMethod: fundBalancingMethodCodeValue
                        },
                        detailTransactionGridLrsApi.agGridApi,
                        function done() { }
                    );

                } else {
                    detailTransactionGridLrsApi.clearGridRows();
                }
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);